import { AVATAR_TINTS } from '../../theme/appColorTokens';

// "Minh Nguyen" -> "MN", "saigon runners club" -> "SR"
export const getInitials = (name: string | undefined | null, max = 2): string => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  return parts
    .slice(0, max)
    .map(p => p[0]!.toUpperCase())
    .join('');
};

// "@runner123" for display. Some accounts use their email address as the username, and
// that must not be shown to other members, so email-like usernames get no handle at all.
export const formatHandle = (username: string | undefined | null): string | undefined =>
  username && !username.includes('@') ? `@${username}` : undefined;

// Stable tint per name so the same person/group keeps its colour across pages.
export const tintForName = (name: string | undefined | null): { tint: string; ink: string } => {
  const s = name || '';
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) | 0;
  return AVATAR_TINTS[Math.abs(hash) % AVATAR_TINTS.length]!;
};

// Shared card surface used by every page section.
export const cardSx = {
  backgroundColor: 'var(--card)',
  border: '1px solid var(--border)',
  borderRadius: '12px',
  boxShadow: 'var(--shadow)',
} as const;
